import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { RegionService } from 'src/app/services/region/region.service';
import { RegionModalService } from 'src/app/services/region-modal/region-modal.service';
import { PaginationInfo } from 'src/app/shared/models';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-regions',
  templateUrl: './regions.component.html',
  styleUrls: ['./regions.component.scss']
})
export class RegionsComponent extends DestructorComponent implements OnInit {

  regions: any[] = [];
  isLoading: boolean = false;
  searchTerm: string = '';
  paginationInfo: PaginationInfo = {
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0,
    firstPage: 1
  };

  constructor(
    private _regionService: RegionService,
    private _regionModalService: RegionModalService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadRegions();
  }

  loadRegions(page: number = 1, search: string = '', filters: any = {}): void {
    this.isLoading = true;
    this.subscriptions.push(
      this._regionService.GetData(page.toString(), search, filters).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status && response.data) {
            this.regions = response.data.data || [];

            // Handle pagination - check if pagination object exists or use direct properties
            if (response.data.pagination) {
              this.paginationInfo = {
                currentPage: response.data.pagination.currentPage || 1,
                firstPage: 1,
                lastPage: response.data.pagination.lastPage || 1,
                perPage: response.data.pagination.perPage || 20,
                total: response.data.pagination.total || 0
              };
            } else {
              // Fallback to direct properties on response.data
              this.paginationInfo = {
                currentPage: response.data.current_page || 1,
                firstPage: 1,
                lastPage: response.data.last_page || 1,
                perPage: response.data.per_page || 20,
                total: response.data.total || 0
              };
            }
          } else {
            this.regions = [];
            this.resetPagination();
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading regions:', error);
          this.isLoading = false;
          this.regions = [];
          this.resetPagination();
          this.cdr.detectChanges();
        }
      })
    );
  }

  private resetPagination(): void {
    this.paginationInfo = {
      currentPage: 1,
      lastPage: 1,
      perPage: 20,
      total: 0,
      firstPage: 1
    };
  }

  onSearch(): void {
    this.loadRegions(1, this.searchTerm);
  }

  onPageChange(page: number): void {
    this.loadRegions(page, this.searchTerm);
  }

  openAddRegionModal(): void {
    this._regionModalService.clearSelectedRegion();
    const modalElement = document.getElementById('kt_modal_region_add_edit');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  openEditRegionModal(region: any): void {
    this._regionModalService.setSelectedRegion(region);
    const modalElement = document.getElementById('kt_modal_region_add_edit');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  deleteRegion(region: any): void {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete the region "${region.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.subscriptions.push(
          this._regionService.DeleteDataById(region._id || region.id).subscribe({
            next: (response: any) => {
              if (response.status) {
                Swal.fire({
                  title: 'Deleted!',
                  text: 'Region has been deleted successfully.',
                  icon: 'success',
                  confirmButtonText: 'OK'
                }).then(() => {
                  this.loadRegions(this.paginationInfo.currentPage, this.searchTerm);
                });
              } else {
                Swal.fire({
                  title: 'Error!',
                  text: response.message || 'Failed to delete region.',
                  icon: 'error',
                  confirmButtonText: 'OK'
                });
              }
            },
            error: (error) => {
              console.error('Error deleting region:', error);
              Swal.fire({
                title: 'Error!',
                text: error.error?.message || 'An error occurred while deleting the region.',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          })
        );
      }
    });
  }

  onRegionAdded(): void {
    this.loadRegions(this.paginationInfo.currentPage, this.searchTerm);
  }

  onRegionUpdated(): void {
    this.loadRegions(this.paginationInfo.currentPage, this.searchTerm);
  }

  trackByFn(index: number, item: any): any {
    return item._id || item.id || index;
  }
}
